import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchProducts, Product } from '@/lib/api';
import ProductCard from '../../products/components/ProductCard';

function ProductGrid({ products }: { products: Product[] }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
      {products.map(product => (
        <ProductCard key={product.slug} product={product} />
      ))}
    </div>
  );
}

function GridSkeleton({ count }: { count: number }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
      {[...Array(count)].map((_, i) => (
        <div key={i} className="animate-pulse">
          <div className="bg-background-100 aspect-[3/4] rounded-xl mb-4"></div>
          <div className="h-3 bg-background-100 rounded mb-2 w-1/2"></div>
          <div className="h-4 bg-background-100 rounded mb-2"></div>
          <div className="h-3 bg-background-100 rounded w-1/3"></div>
        </div>
      ))}
    </div>
  );
}

export default function FeaturedProducts() {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProducts()
      .then(data => setProducts(data.filter(p => p.published)))
      .finally(() => setLoading(false));
  }, []);

  const mistProducts = products.filter(p => p.category === 'ミスト');
  const otherProducts = products.filter(p => p.category !== 'ミスト');

  return (
    <section id="products" className="py-24 px-6 bg-background-50" data-product-shop>
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-14">
          <div>
            <p className="text-xs tracking-[0.3em] text-primary-500 mb-3 uppercase"
              style={{ fontFamily: "var(--font-heading)" }}>
              Items
            </p>
            <h2 className="text-4xl md:text-5xl font-light text-foreground-950 leading-tight"
              style={{ fontFamily: "var(--font-heading)" }}>
              Featured Goods
            </h2>
          </div>
          <Link
            to="/products"
            className="hidden sm:flex items-center gap-2 text-sm text-foreground-600 hover:text-primary-500 transition-colors tracking-[0.15em] whitespace-nowrap cursor-pointer mt-4 sm:mt-0"
            style={{ fontFamily: "var(--font-heading)" }}
          >
            View All <i className="ri-arrow-right-up-line"></i>
          </Link>
        </div>

        {loading ? (
          <GridSkeleton count={4} />
        ) : (
          <>
            <div className="mb-16">
              <h3 className="text-xl tracking-[0.3em] text-foreground-500 mb-6 uppercase"
                style={{ fontFamily: "var(--font-heading)" }}>
                グッズ
              </h3>
              <ProductGrid products={otherProducts} />
            </div>

            <div>
              <div className="flex flex-col lg:flex-row lg:items-start gap-2 lg:gap-8 mb-6">
                <h3 className="text-xl tracking-[0.3em] text-foreground-500 uppercase whitespace-nowrap"
                  style={{ fontFamily: "var(--font-heading)" }}>
                  ミスト
                </h3>
                <div className="lg:flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <i className="ri-moon-clear-line text-primary-400 text-xl"></i>
                    <p className="text-xl text-foreground-950 tracking-wide"
                      style={{ fontFamily: "var(--font-heading)" }}>
                      Moon Charge Room Mist
                    </p>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed whitespace-pre-line"
                    style={{ fontFamily: "var(--font-body)" }}>
{`満月の夜、天然石をひとつひとつ浄化して仕込んだルームスプレー。満月のパワーをたっぷり秘めた一本で、お部屋の空気をすっと浄化し、運気もふわりとアップ。
仕事前のリセットに、寝る前のひとときに。自分へのご褒美にも、大切な人へのギフトにも最適な、ROFFらしい"整える"アイテムです。`}
                  </p>
                </div>
              </div>
              <ProductGrid products={mistProducts} />
            </div>

            <div className="text-center mt-10 sm:hidden">
              <Link
                to="/products"
                className="inline-flex items-center gap-2 text-sm text-foreground-600 hover:text-primary-500 transition-colors tracking-[0.15em] cursor-pointer"
                style={{ fontFamily: "var(--font-heading)" }}
              >
                View All <i className="ri-arrow-right-up-line"></i>
              </Link>
            </div>
          </>
        )}
      </div>
    </section>
  );
}
